module.exports = __webpack_public_path__ + "static/media/idfc_card.61884413.svg";